import { render, staticRenderFns } from "./gzjk.vue?vue&type=template&id=73d38fbb&scoped=true"
import script from "./gzjk.vue?vue&type=script&lang=js"
export * from "./gzjk.vue?vue&type=script&lang=js"
import style0 from "./gzjk.vue?vue&type=style&index=0&id=73d38fbb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d38fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d38fbb')) {
      api.createRecord('73d38fbb', component.options)
    } else {
      api.reload('73d38fbb', component.options)
    }
    module.hot.accept("./gzjk.vue?vue&type=template&id=73d38fbb&scoped=true", function () {
      api.rerender('73d38fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/messagejk/gzjk.vue"
export default component.exports